<template>
  <div v-redirect-if-no-permission:LOCATIONS>
    <DataTable
      :url="api.ACTIONS.LANDMARKS"
      :fieldsHiddenMain="[
        'deleted_at',
        'updated_at',
        'radius',
        'type',
        'polygon',
        'landmark_type',
        'clusters',
      ]"
      :titles="titles"
      :actionsExtraMain="actionsExtraMain"
      :formatter="formatter"
      :initialUrlSearchParams="addType"
      perPage="100"
      :title="$t('locationsPage.landmarksTitle')"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";

export default {
  name: "LandmarkList",
  title() {
    return this.$t("locationsPage.landmarksTitle");
  },
  components: { DataTable },
  computed: {
    titles() {
      return {
        id: "#",
        created_at: this.$t("locationsPage.dateCreated"),
        street_number: this.$t("locationsPage.streetNumber"),
        street_name: this.$t("locationsPage.streetName"),
      };
    },
    addType() {
      const par = new URLSearchParams();
      par.append("landmark_type", "NORMAL");
      return par;
    },
    actionsExtraMain() {
      return {
        edit: {
          action: (item) => `/landmarks/${item.id}`,
        },
        add: {
          link: `/landmarks/add`,
        },
      };
    },
    formatter() {
      return {
        created_at(value) {
          return formatCompanyTime(value, "DD-MM-YYYY HH:mm");
        },
        centroid(value) {
          if (value) return JSON.stringify(value.coordinates);
        },
      };
    },
  },
};
</script>

<style scoped></style>
